import React, { useContext, useEffect, useState } from "react";

import {
  Card,
  Col,
  Row,
  Typography,
  Tooltip,
  Progress,
  Upload,
  message,
  Button,
  Timeline,
  Radio, Spin,
} from "antd";
import {
  ToTopOutlined,
  MenuUnfoldOutlined,
  RightOutlined,
} from "@ant-design/icons";
import Paragraph from "antd/lib/typography/Paragraph";

import Echart from "./ECharts";
import LineChart from "./LineChart";

import nagarikAawaz from "../../assets/images/nagarik.jpg";
import { fetchDashboardData } from "../../services/dashboard.service";
import moment from "moment";
import { GlobalContext } from "../../context/GlobalContext";

const profile = [
  <svg
    width="22"
    height="22"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={0}
  >
    <path
      d="M9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6Z"
      fill="#fff"
    ></path>
    <path
      d="M17 6C17 7.65685 15.6569 9 14 9C12.3431 9 11 7.65685 11 6C11 4.34315 12.3431 3 14 3C15.6569 3 17 4.34315 17 6Z"
      fill="#fff"
    ></path>
    <path
      d="M12.9291 17C12.9758 16.6734 13 16.3395 13 16C13 14.3648 12.4393 12.8606 11.4998 11.6691C12.2352 11.2435 13.0892 11 14 11C16.7614 11 19 13.2386 19 16V17H12.9291Z"
      fill="#fff"
    ></path>
    <path
      d="M6 11C8.76142 11 11 13.2386 11 16V17H1V16C1 13.2386 3.23858 11 6 11Z"
      fill="#fff"
    ></path>
  </svg>,
];
const { Title, Text } = Typography;

function Dashboard() {
  const [loading, setLoading] = useState(true);
  const { setBreadCrumb } = useContext(GlobalContext);
  const [state, setState] = useState({
    survivorsIdentifiedCount: [],
    dashboardData: [],
    dashboardMonths: [],
  });

  useEffect(() => {
    setBreadCrumb([
      {
        title: 'Dashboard',
        link: '/dashboard',
      },
    ]);
    fetchDashboardData()
      .then((response) => {
        console.log(response);
        const CompletedSurvivors = response.data.pendingCompletedSurvivorsCount.find(x => x.phase === 'completed');
        const PendingSurvivors = response.data.pendingCompletedSurvivorsCount.find(x => x.phase === 'pending');
        const survivorsIdentifiedCount = [
          {
            today: "Total Survivors",
            title: response.data?.totalSurvivors,
            persent: "+",
            icon: profile,
            bnb: "bnb2",
          },
          {
            today: "Total Districts",
            title: response.data.totalDistricts,
            persent: "+",
            icon: profile,
            bnb: "bnb2",
          },
          {
            today: "Completed Survivors",
            title: CompletedSurvivors ? CompletedSurvivors.count : 0,
            persent: "+",
            icon: profile,
            bnb: "bnb2",
          },
          {
            today: "Pending Survivors",
            title: PendingSurvivors ? PendingSurvivors.count : 0,
            persent: "+",
            icon: profile,
            bnb: "bnb2",
          },
        ];
        const months = [];
        const counts = [];
        for(const data of response.data.survivorsLast12Month) {
          months.push(moment(data.month).format('MMM'));
          counts.push(data.count);
        }
        setState({
          survivorsIdentifiedCount: survivorsIdentifiedCount,
          dashboardData: counts,
          dashboardMonths: months,
        });
      })
      .catch((error) => {
        console.log(error);
      })
        .finally(() => {setLoading(false)});
  }, []);

  return (
    <>
      <Spin spinning={loading}>
        <div className="layout-content">
        <Row className="rowgap-vbox" gutter={[24, 0]}>
          {state.survivorsIdentifiedCount.map((c, index) => (
            <Col
              key={index}
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={6}
              className="mb-24"
            >
              <Card bordered={false} className="criclebox ">
                <div className="number">
                  <Row align="middle" gutter={[24, 0]}>
                    <Col xs={18}>
                      <span>{c.today}</span>
                      <Title level={3}>
                        {c.title} <small className={c.bnb}>{c.persent}</small>
                      </Title>
                    </Col>
                    <Col xs={6}>
                      <div className="icon-box">{c.icon}</div>
                    </Col>
                  </Row>
                </div>
              </Card>
            </Col>
          ))}
        </Row>

        <Row gutter={[24, 0]}>
          <Col xs={24} sm={24} md={12} lg={12} xl={10} className="mb-24">
            <Card bordered={false} className="criclebox h-full">
              <Echart data={state.dashboardData} months={state.dashboardMonths}/>
            </Card>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={14} className="mb-24">
            <Card bordered={false} className="criclebox h-full">
              <LineChart data={state.dashboardData} months={state.dashboardMonths}/>
            </Card>
          </Col>
        </Row>

        <Row gutter={[24, 0]}>
          <Col xs={24} md={12} sm={24} lg={12} xl={14} className="mb-24">
            <Card bordered={false} className="criclebox h-full">
              <Row gutter>
                <Col
                  xs={24}
                  md={12}
                  sm={24}
                  lg={12}
                  xl={14}
                  className="mobile-24"
                >
                  <div className="h-full col-content p-20">
                    <div className="ant-muse">
                      <Title level={5}>Nagarik Aawaz</Title>
                      <Text>FOR JUST AND PEACEFUL NEPAL</Text>

                      <Paragraph className="lastweek mb-36">
                      A non-profit organization that practices grounded values of peace building to create agencies of peace.
                      </Paragraph>
                    </div>
                    <div className="card-footer">
                      <a className="icon-move-right" href="https://nagarikaawaz.org.np/">
                        Read More
                        {<RightOutlined />}
                      </a>
                    </div>
                  </div>
                </Col>
                <Col
                  xs={24}
                  md={12}
                  sm={24}
                  lg={12}
                  xl={10}
                  className="col-img"
                >
                  <div className="ant-cret text-right">
                    <img src={nagarikAawaz} alt="" className="border10" />
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>

          <Col xs={24} md={12} sm={24} lg={12} xl={10} className="mb-24">
            <Card bordered={false} className="criclebox card-info-2 h-full">
              <div className="gradent h-full col-content">
                <div className="card-content">
                  <Title level={5}>Who We Are</Title>
                  <p>
                  Nagarik Aawaz (NA) is a non-profit organization that practices grounded values of peace building to create agencies of peace (in the forms of peacebuilding organizations, ambassadors,
                  </p>
                </div>
                <div className="card-footer">
                  <a className="icon-move-right" href="https://nagarikaawaz.org.np/about/">
                    Read More
                    <RightOutlined />
                  </a>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      </Spin>
    </>
  );
}

export default Dashboard;
